"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HotlistValue = void 0;
const HotlistUnit_1 = require("./HotlistUnit");
class HotlistValue {
    constructor(obj) {
        for (const prop in obj) {
            switch (prop) {
                case 'unit':
                    this.unit = (0, HotlistUnit_1.getHotlistUnit)(obj[prop]);
                    break;
                default:
                    this[prop] = obj[prop];
                    break;
            }
        }
    }
}
exports.HotlistValue = HotlistValue;
//# sourceMappingURL=HotlistValue.js.map